export * from './sales-person-edition.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SessionService } from '../../../../../../_services';
import { TrainingSessionCompany } from '../../../../../../_services/session/company';

@Component({
    selector: 'registration-sales-person-edition',
    templateUrl: 'sales-person-edition.component.html',
    styleUrls: [
        '../../registration.component.scss',
        '../../../../../_shared/label/label.component.scss',
    ],
    providers: [],
})
export class SessionSalesPersonEditionComponent implements OnInit {
    @Input() tsCompany: TrainingSessionCompany;

    constructor(private sessionService: SessionService) {}

    ngOnInit() {}

    searchSalesPersons(keyword: string) {
        return this.sessionService.searchBackofficeUsers(keyword);
    }

    formatSalesPerson({ firstname, lastname }) {
        return `${firstname} ${lastname}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/sales-person-edition/sales-person-edition.component.ts